module.exports = __webpack_public_path__ + "img/gadgets.5c9a7461.jpg";